<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5><b>DFS Betting</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                <CInput
                  placeholder="Enter Tournament Name"
                  v-model="tournamentName"
                />
              </CCol>
              <CCol sm="12">
                <CInput
                  placeholder="Enter Betting Question"
                  v-model="betquestion"
                />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Team 1" v-model="Quiztitle" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Team 2" v-model="Quizquestion" />
              </CCol>
              <CCol sm="4">
                <CInput placeholder="Enter option 0" v-model="Quizoptions[0]" />
              </CCol>

              <CCol sm="4">
                <CInput placeholder="Enter option 1" v-model="Quizoptions[1]" />
              </CCol>
              <CCol sm="4">
                <CInput placeholder="Enter option 2" v-model="Quizoptions[2]" />
              </CCol>
              <!-- <CCol sm="3">
                <CInput placeholder="Enter option 3" v-model="Quizoptions[3]" />
              </CCol> -->

              <!-- <CCol sm="6">
                <CInput
                  placeholder="Enter Quiz Answer"
                  v-model.number="Quizanswer"
                  type="hidden"
                />
              </CCol> -->
              <!-- <CCol sm="6">
                <CInput
                  placeholder="Enter Quiz point"
                  v-model.number="quizpoint"
                />
              </CCol> -->

              <CCol sm="12">
                <CRow>
                  <CCol sm="6">
                    <!-- <datetime format="MM/DD/YYYY" width="300px" v-model="val"></datetime> -->
                    <label>Start Date & Time</label>
                    <VueCtkDateTimePicker v-model="starttime" />
                    <!-- <Datepicker
                  format="YYYY-MM-DD h:i:s"
                  v-model="starttime"
                  width="100%"
                /> -->
                    <br />
                  </CCol>

                  <CCol sm="6">
                    <label>End Date & Time</label>
                    <VueCtkDateTimePicker v-model="endtime" />
                    <br />
                  </CCol>
                </CRow>
              </CCol>

              <!-- <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Scramble</span
                    >

                    <input
                      v-model="scramble"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold">DFS</span>

                    <input
                      v-model="dfs"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                  <CCardBody v-if="dfsbody">
                    <CInput
                      placeholder="Enter Match ID"
                      v-model.number="matchId"
                    />
                  </CCardBody>
                </CCard>
              </CCol> -->
              <!-- <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose type</h5> </CCol>
                      <CCol sm="2"
                        ><input
                          type="radio"
                          value="normal"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Normal</span>
                      </CCol>
                      <CCol sm="3"
                        ><input
                          type="radio"
                          value="playAlong"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Play Along</span>
                      </CCol>
                      <CCol sm="2"> </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol> -->
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Status</span
                    >

                    <input
                      type="checkbox"
                      value="test"
                      v-model="status"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Bonus</span
                    >

                    <input
                      v-model="isBonus"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                  <CCardBody v-if="isBonusbody">
                    <CInput
                      placeholder="Enter Bonus Point"
                      v-model.number="bonus"
                    />
                  </CCardBody>
                </CCard>
              </CCol>
              <!-- <CCol sm="6">
                <div>
                  <div>
                    <label> Quiz Image </label><br />
                    <input
                      type="file"
                      @change="previewImage"
                      accept="image/*"
                    />
                  </div>
                  <div>
                    <p>
                      Progress: {{ uploadValue.toFixed() + "%" }}
                      <progress
                        id="progress"
                        :value="uploadValue"
                        max="100"
                      ></progress>
                    </p>

                    <CButton
                      color="success"
                      @click="onUpload()"
                      v-if="uploadbtn"
                      >Upload</CButton
                    >
                    <br />
                  </div>
                </div>
                <div v-if="imageData != null">
                  <img
                    class="preview"
                    :src="picture"
                    style="width: 200px; height: 200px"
                  />

                  <br />
                  <br />
                </div>
              </CCol> -->
              <CCol sm="12">
                <label>Choose a Token</label>
                <Vselect :options="networks" v-model="selectedNetwork" />
                <!-- <CInput v-model="tournamentTokenName" type="text" /> -->
                <br />
              </CCol>
              <CCol sm="6">
                <label>Enter Minimum Amount</label>
                <CInput
                  placeholder="Enter Minimum Amount"
                  v-model.number="minimum"
                />
              </CCol>
              <CCol sm="6">
                <label>Enter Sports Name (Ex: Cricket, Football)</label>
                <CInput placeholder="Enter sports name" v-model="sportstype" />
              </CCol>
              <CCol sm="12" style="text-align: center !important">
                <CButton color="success" style="width: 20%" @click="savequiz()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { Vselect } from "@/components";
import Swal from "sweetalert2";
import firebase from "firebase";
const db = firebase.firestore();

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { secondaryDatabase } from "./secondary.js";
import axios from "axios";
//  const Dinodb = firebase.initializeApp(firebaseConfig2);
import moment from "moment";
export default {
  components: { VueCtkDateTimePicker, Vselect },
  data() {
    return {
      tournamentName: "",
      isBonus: false,
      isBonusbody: false,
      bonus: "",
      enableDate: false,
      Quiztitle: "",
      Quizquestion: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      Quizoptions: [],
      Quizanswer: "",
      QuizImage: "",
      starttime: "",
      endtime: "",
      quizpoint: "",
      status: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,
      quiztype: "",
      scramble: false,
      dfs: true,
      dfsbody: false,
      quizimg: true,
      starttimestap: "",
      matchId: "",
      endtimestap: "",
      datebody: false,
      usercount: 0,
      bettingamount: 0,
      minimum: 0,
      tableData: [],
      countmatchId: 1,
      team1usercount: 0,
      team2usercount: 0,
      team3usercount: 0,
      team1totalAmount: 0,
      team2totalAmount: 0,
      team3totalAmount: 0,
      betquestion: "",
      sportstype: "",
      selectedNetwork: "",
      networks: [],
      allNetworks: [],
      respStatus: false,
    };
  },
  watch: {
    starttime() {
      this.starttimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.starttime)
      );
    },
    endtime() {
      this.endtimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.endtime)
      );
    },

    dfs() {
      if (this.dfs == true) {
        this.dfsbody = true;
      } else {
        this.dfsbody = false;
      }
    },
    isBonus() {
      if (this.isBonus == true) {
        this.isBonusbody = true;
      } else {
        this.isBonusbody = false;
      }
    },
  },
  methods: {
    async getAuthID() {
      const url = "https://admin.rage.fan:8080/account/login";
      const header = {
        headers: {
          AppVersion: "1.0.1",
          DeviceId: "f2a6796ce98b26b8",
          DeviceType: "android",
          OsVersion: "30",
          DeviceToken:
            "eTTVXqPCQ760IQHui0T6qx:APA91bHRD1JWp8h2yKwtLF9zmKc-CL92Ib_pFkItBe1WPiF5Po42q8E95s63xX_2-7YMYhH2t3kW8ryflYAJE_pxKqskdqFlbXZlHrw7i3ipFyVk5WXk6BBdbt2OP6NNOoZzJUsLTifW",
          Wallet_Address: "0xC4E86Ea018e658764AeAD2680d827E401311F523",
          Wallet_Type: "AndroidWeb3Wallet",
        },
      };
      let resData = await axios.post(url, null, header);
      if (resData.data.Status) this.respStatus = resData.data.Status;
      console.log(resData.data);
      // console.log(resData.data.Result.Token);
      this.getWallets(resData.data.Result.Token);
    },

    async getWallets(headerAuth) {
      const url = "https://admin.rage.fan:8080/profile/wallets";
      const header = {
        headers: {
          Authorization: headerAuth,
          allToken: true,
        },
      };
      let resData = await axios.get(url, {
        headers: {
          Authorization: headerAuth,
          allToken: true,
        },
      });
      // console.log("Got resp", resData.data.Result);

      this.allNetworks = resData.data.Result;

      for (let i = 0; i < resData.data.Result.length; i++) {
        this.networks.push(resData.data.Result[i].Name);
      }
    },

    async savequiz() {
      console.log("selectedNetwork", this.selectedNetwork);
    
      let wallet = this.allNetworks.find((o) => o.Name == this.selectedNetwork);
      let quizOptions = this.Quizoptions.map((e) => e.trim());

      //   const url = "https://admin.rage.fan:8080/account/login";
      //   const header = {
      //     headers: {
      //       AppVersion: "1.0.1",
      //       DeviceId: "f2a6796ce98b26b8",
      //       DeviceType: "android",
      //       OsVersion: "30",
      //       DeviceToken:
      //         "eTTVXqPCQ760IQHui0T6qx:APA91bHRD1JWp8h2yKwtLF9zmKc-CL92Ib_pFkItBe1WPiF5Po42q8E95s63xX_2-7YMYhH2t3kW8ryflYAJE_pxKqskdqFlbXZlHrw7i3ipFyVk5WXk6BBdbt2OP6NNOoZzJUsLTifW",
      //       Wallet_Address: "0xC4E86Ea018e658764AeAD2680d827E401311F523",
      //       Wallet_Type: "AndroidWeb3Wallet",
      //     },
      //   };
      //   let resData = await axios.post(url, null, header);
      if (this.respStatus) {
        let quizdate = new Date();

        if (this.tournamentName == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Tournament Name ",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.betquestion == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Betting Question ",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.Quiztitle == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Team 1 ",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.Quizquestion == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Team 2",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.starttimestap == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter StartDate",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.endtimestap == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter EndDate",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.isBonus && this.bonus == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Bonus Point",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.Quizoptions.length == 0) {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter Quiz Option",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.sportstype == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter sportstype",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.selectedNetwork == "") {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Choose Token for Prediction",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (this.minimum == 0 && this.bonus == 0) {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please Enter a Bonus ",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        //  else if (this.minimum == 0) {
        //   Swal.fire({
        //     position: "center",
        //     icon: "warning",
        //     title: "Please Enter Minimum amount",
        //     showConfirmButton: false,
        //     timer: 3000,
        //   });
        // }
        //    else if (this.picture == null) {
        //     Swal.fire({
        //       position: "center",
        //       icon: "warning",
        //       title: "Please Enter Quiz Image",
        //       showConfirmButton: false,
        //       timer: 3000,
        //     });
        //   } else if (this.quizpoint == "") {
        //     Swal.fire({
        //       position: "center",
        //       icon: "warning",
        //       title: "Please Enter Quiz Point",
        //       showConfirmButton: false,
        //       timer: 3000,
        //     });
        //   }
        else {
            let bettingToken = secondaryDatabase.collection("bettingtest").where("matchId","==",this.countmatchId);
    let bonusDoc = await bettingToken.get(); 
    // console.log(bonusDoc);
    this.countmatchId=  bonusDoc.docs.length>0? this.countmatchId+1:this.countmatchId;
    // console.log("COUNTMATCHID",this.countmatchId);
          let messagetitle = "New Betting  Live on RageFan";
          let messagetext = this.starttimestap
            ? this.Quiztitle +
              " vs " +
              this.Quizquestion +
              " live from " +
              moment(this.starttimestap.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ) +
              " to " +
              moment(this.endtimestap.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ) +
              " Answer quickly before it expires."
            : this.Quiztitle +
              " vs " +
              this.Quizquestion +
              " Answer quickly before it expires";
          let picture =
            "https://firebasestorage.googleapis.com/v0/b/token-geomine.appspot.com/o/tokenImages%2F20211023T111930708Z171255.png?alt=media&token=ae68d137-1906-4cf9-bdee-5f9d7e7e9013";
          let data = {
            messagetitle,
            messagetext,
            picture,
          };
          // axios.post(
          //   "https://us-central1-token-geomine.cloudfunctions.net/dfs/sentQuizNotification",
          //   { ...data }
          // );
          //   axios.post(
          //     "http://localhost:5000/token-geomine/us-central1/dfs/sentQuizNotification",
          //     { ...data }
          //   );

          secondaryDatabase
            .collection("bettingtest")
            .add({
              betquestion: this.betquestion,
              team1: this.Quiztitle,
              team2: this.Quizquestion,
              options: quizOptions,
              answer: null,
              // image: this.picture,
              status: this.status,
              // quiztype: this.quiztype,
              starttime: this.starttimestap,
              endtime: this.endtimestap,
              dfs: this.dfs,
              bettingamount: this.bettingamount,
              usercount: this.usercount,
              minimum: this.minimum,
              matchId: this.countmatchId,
              team1usercount: this.team1usercount,
              team2usercount: this.team2usercount,
              team3usercount: this.team3usercount,
              team1totalAmount: this.team1totalAmount,
              team2totalAmount: this.team2totalAmount,
              team3totalAmount: this.team3totalAmount,
              isBonus: this.isBonus,
              bonus: this.bonus,
              tournamentName: this.tournamentName,
              sportstype: this.sportstype,
              tokenName: this.selectedNetwork,
              tokenId: wallet.Id,
              // point: this.quizpoint,
              // matchId: this.matchId,
              quizdate: firebase.firestore.Timestamp.fromDate(
                new Date(quizdate)
              ),
            })
            .then(() => {
              this.betquestion = "";
              this.Quiztitle = "";
              this.Quizquestion = "";
              this.Quizoptions = [];
              this.Quizanswer = "";
              this.picture = "";
              this.status = "";
              this.quiztype = "";
              (this.starttime = ""),
                (this.endtime = ""),
                (this.scramble = ""),
                (this.dfs = ""),
                (this.quizpoint = ""),
                (this.picture = "");
              (this.option1 = ""),
                (this.option2 = ""),
                (this.option3 = ""),
                (this.option4 = "");
              this.tournamentName = "";
              this.matchId = "";
              this.sportstype = "";
              secondaryDatabase
                .collection("settings")
                .doc("config")
                .update({
                  count: this.countmatchId + 1,
                })
                .then((snapshot) => {
                  //   snapshot.forEach((doc) => {
                  this.countmatchId = snapshot.data().count;

                  //   });
                });
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Data Saved Successfully",
                showConfirmButton: false,
                timer: 3000,
              });

              this.$router.push({ name: "TableNft" });
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        }
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: resData.data.Message,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        quizTitle: doc.data().team1,
        question: doc.data().team2,
        options: doc.data().options,
        answer: doc.data().answer,
        status: doc.data().status,
        // image: doc.data().image,
        // quiztype: doc.data().quiztype,
        starttime: doc.data().starttime,
        endtime: doc.data().endtime,
        scramble: doc.data().scramble,
        // dfs: doc.data().dfs,
        Match: doc.data().team1 + " vs " + doc.data().team2,
        Date: moment(doc.data().quizdate.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        StartDate: moment(doc.data().starttime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        EndDate: moment(doc.data().endtime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
      };
      return smallDocument;
    },
    count() {
      secondaryDatabase
        .collection("settings")
        .doc("config")
        .get()
        .then((snapshot) => {
          //   snapshot.forEach((doc) => {
          this.countmatchId = snapshot.data().count;
         console.log("COUNTTT",this.countmatchId);
          //   });
        });

    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];

      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {},
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
  },
  created() {
    this.count();
    this.getAuthID();
    // this.transactionhash();
  },
};
</script>